// extracted by css-extract-rspack-plugin
module.exports =  {"subsTxt":"ZOFp4","logoutToast":"Erlrh","spin":"olosY"};